import { TableRow } from '@razorpay/blade/components';
import { SalaryComponent } from 'components/SalaryComponents/types';
import React from 'react';
import ActionCell from './components/ActionCell';
import AmountCell from './components/AmountCell';
import ComponentCell from './components/ComponentCell';
import TypeCell from './components/TypeCell';
import { SalaryStructureComponent } from './types';

interface SalaryRowProps {
  item: SalaryStructureComponent;
  searchSalaryComponents: (ignoreKeys?: string[]) => SalaryComponent[];
}

const areEqual = (prevProps: Readonly<SalaryRowProps>, nextProps: Readonly<SalaryRowProps>) => {
  if (prevProps.item.id !== nextProps.item.id) {
    return false;
  }

  if (prevProps.item.formula !== nextProps.item.formula) {
    return false;
  }

  if (prevProps.item.salaryComponent.id !== nextProps.item.salaryComponent.id) {
    return false;
  }
  if (prevProps.item.valueType !== nextProps.item.valueType) {
    return false;
  }

  return true;
};

const SalaryRow = ({ item, searchSalaryComponents }: SalaryRowProps) => {
  return (
    <TableRow item={item}>
      <ComponentCell item={item} searchSalaryComponents={searchSalaryComponents} />
      <AmountCell item={item} />
      <TypeCell item={item} />
      <ActionCell item={item} />
    </TableRow>
  );
};

SalaryRow.displayName = 'SalaryRow';

export default React.memo(SalaryRow, areEqual);
